// Date Picker — single & range, reste ouvert après le 1er clic en range.
// data-sticky => ne ferme pas automatiquement (il faut cliquer “OK”).
(function () {
    const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    const parse = (s) => {
        const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || '');
        if (!m) return null;
        const d = new Date(+m[1], +m[2]-1, +m[3]);
        return isNaN(+d) ? null : d;
    };
    const sameDay = (a,b) => a && b &&
        a.getFullYear()===b.getFullYear() && a.getMonth()===b.getMonth() && a.getDate()===b.getDate();

    function closeAll(except=null){
        document.querySelectorAll('[data-date-picker].is-open').forEach(r=>{
            if(r!==except) r.classList.remove('is-open');
            r.querySelector('.dp__input')?.setAttribute('aria-expanded','false');
        });
    }

    function buildSkeleton(root){
        if(root.__built) return;
        root.__built = true;

        let pop = root.querySelector('.dp__popover');
        if(!pop){
            pop = document.createElement('div');
            pop.className = 'dp__popover';
            root.appendChild(pop);
        }

        pop.innerHTML = `
      <div class="dp__header">
        <div class="dp__month"></div>
        <div class="dp__nav">
          <button type="button" class="dp__btn" data-prev aria-label="Mois précédent">‹</button>
          <button type="button" class="dp__btn" data-next aria-label="Mois suivant">›</button>
        </div>
      </div>
      <div class="dp__weekgrid"></div>
      <div class="dp__grid"></div>
      <div class="dp__footer">
        <button type="button" class="dp__action" data-clear>Effacer</button>
        <button type="button" class="dp__action" data-close>OK</button>
      </div>
    `;

        // Empêche la fermeture par le handler global quand on clique DANS le popover
        pop.addEventListener('click', (e)=> e.stopPropagation());

        const wg = pop.querySelector('.dp__weekgrid');
        ['Lu','Ma','Me','Je','Ve','Sa','Di'].forEach(lbl=>{
            const el = document.createElement('div');
            el.className='dp__dow'; el.textContent=lbl; wg.appendChild(el);
        });

        pop.addEventListener('click', (e)=>{
            const st = root.__state; if(!st) return;
            if(e.target.closest('[data-prev]')){
                st.month--; if(st.month<0){st.month=11; st.year--;} render(root);
            } else if(e.target.closest('[data-next]')){
                st.month++; if(st.month>11){st.month=0; st.year++;} render(root);
            } else if(e.target.closest('[data-clear]')){
                st.start=null; st.end=null; syncInput(root); render(root);
            } else if(e.target.closest('[data-close]')){
                closeAll();
            }
        });
    }

    function render(root){
        buildSkeleton(root);

        const st = root.__state;
        const grid = root.querySelector('.dp__grid');
        const label = root.querySelector('.dp__month');
        const rangeMode = root.hasAttribute('data-range');

        const min = parse(root.getAttribute('data-min'));
        const max = parse(root.getAttribute('data-max'));

        const monthLabel = new Date(st.year, st.month, 1)
            .toLocaleDateString('fr-FR',{month:'long',year:'numeric'});
        label.textContent = monthLabel[0].toUpperCase()+monthLabel.slice(1);

        grid.innerHTML='';

        const first = new Date(st.year, st.month, 1);
        let offset = (first.getDay()+6)%7; // Lundi=0
        const startDate = new Date(st.year, st.month, 1 - offset);
        const today = new Date(); today.setHours(0,0,0,0);

        for(let i=0;i<42;i++){
            const d = new Date(startDate); d.setDate(startDate.getDate()+i);

            const cell = document.createElement('button');
            cell.type='button'; cell.className='dp__cell';
            cell.textContent=String(d.getDate());
            cell.addEventListener('click', (e)=> e.stopPropagation()); // ← clé anti-fermeture

            if(d.getMonth()!==st.month) cell.classList.add('is-outside');
            if(sameDay(d,today)) cell.classList.add('is-today');

            let disabled = (min && d<min) || (max && d>max);
            if(disabled) cell.classList.add('is-disabled');

            if(rangeMode){
                if(st.start && sameDay(d,st.start)) cell.classList.add('is-selected','is-range-edge');
                if(st.end && sameDay(d,st.end)) cell.classList.add('is-selected','is-range-edge');
                if(st.start && st.end && d>st.start && d<st.end) cell.classList.add('is-in-range');
            } else if(st.start && sameDay(d,st.start)){
                cell.classList.add('is-selected');
            }

            if(!disabled){
                cell.addEventListener('click', ()=>{
                    if(!rangeMode){
                        st.start = new Date(d);
                        syncInput(root); render(root); closeAll(); return;
                    }

                    // Mode range — NE PAS fermer après 1er clic
                    if(!st.start || (st.start && st.end)){
                        st.start = new Date(d); st.end = null;
                    } else {
                        if(d < st.start){ st.end=new Date(st.start); st.start=new Date(d); }
                        else { st.end = new Date(d); }
                    }

                    syncInput(root); render(root);

                    if(st.start && st.end && !root.hasAttribute('data-sticky')){
                        closeAll();
                    }
                });
            }

            grid.appendChild(cell);
        }
    }

    function syncInput(root){
        const rangeMode = root.hasAttribute('data-range');
        const input = root.querySelector('.dp__input');
        const startField = root.querySelector('input[name="start"]');
        const endField = root.querySelector('input[name="end"]');
        const st = root.__state;

        if(!rangeMode){
            const v = st.start ? fmt(st.start) : '';
            input && (input.value=v);
            startField && (startField.value=v);
            endField && (endField.value='');
        } else {
            const v1 = st.start ? fmt(st.start) : '';
            const v2 = st.end ? fmt(st.end) : '';
            input && (input.value = (v1 && v2) ? `${v1} — ${v2}` : (v1 ? `${v1} — ` : ''));
            startField && (startField.value=v1);
            endField && (endField.value=v2);
        }
    }

    function open(root){
        closeAll(root);
        if(!root.__state){
            const now = new Date();
            root.__state = { year: now.getFullYear(), month: now.getMonth(), start:null, end:null };

            // pré-remplissages éventuels
            const s0 = root.querySelector('input[name="start"]')?.value;
            const e0 = root.querySelector('input[name="end"]')?.value;
            const s = parse(s0), e = parse(e0);
            if(s){ root.__state.start=s; root.__state.year=s.getFullYear(); root.__state.month=s.getMonth(); }
            if(e) root.__state.end=e;
        }
        root.classList.add('is-open');
        root.querySelector('.dp__input')?.setAttribute('aria-expanded','true');
        render(root); syncInput(root);
    }

    function toggle(root){
        if(root.classList.contains('is-open')) closeAll();
        else open(root);
    }

    // Gestion globale ouverture/fermeture
    document.addEventListener('click', (e)=>{
        const input = e.target.closest('.dp__input');
        const inPopover = e.target.closest('.dp__popover');
        const root = (input || inPopover) ? (e.target.closest('[data-date-picker]') || (inPopover && inPopover.parentElement.closest('[data-date-picker]'))) : null;

        if(input && root){ toggle(root); return; }
        if(inPopover) return;            // clique DANS le popover => ne ferme pas
        if(document.querySelector('[data-date-picker].is-open')) closeAll(); // clic ailleurs => ferme
    });

    document.addEventListener('keydown', (e)=>{ if(e.key==='Escape') closeAll(); });

    // A11y
    document.querySelectorAll('[data-date-picker]').forEach(root=>{
        const input = root.querySelector('.dp__input');
        if(input){
            input.setAttribute('role','combobox');
            input.setAttribute('aria-haspopup','dialog');
            input.setAttribute('aria-expanded','false');
            input.readOnly = true;
        }
    });
})();
